import React, { useState, useEffect } from 'react';
import '../styles/baim.css';
import Sidebar from './Sidebar';
import HeroSection from './HeroSection';
import IdentitySection from './IdentitySection';
import ArsenalSection from './ArsenalSection';
import OfferSection from './OfferSection';
import Footer from './Footer';

const BaimLanding = () => {
  const [activeSection, setActiveSection] = useState('hero');

  // Handle scroll to update active section
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'identity', 'arsenal', 'offer', 'contact'];
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      for (const sectionId of sections) {
        const element = document.getElementById(sectionId);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to section handler
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="paper-bg scroll-container custom-scrollbar relative">
      {/* Sidebar Navigation */}
      <Sidebar 
        activeSection={activeSection} 
        onNavigate={scrollToSection} 
      />

      {/* Main Content */}
      <main className="md:ml-[70px] min-h-screen">
        <HeroSection />
        <IdentitySection />
        <ArsenalSection />
        <OfferSection />
        <Footer />
      </main>
    </div>
  );
};

export default BaimLanding;
